import * as Plugin from './Plugin';
import Vue from 'vue';
import Vuex from 'vuex';
import authentication from './Module/Authentication';
import global from './Module/Global';
import location from './Module/Location';
import persist from './Persist';

// Attach Vuex
// -----------------------------------------------------------------------------

Vue.use(Vuex);

// Setup Store
// -----------------------------------------------------------------------------

const store = new Vuex.Store<any>({
	modules: {
		authentication,
		global,
		location,
	},
	plugins: [persist, Plugin.Example],
});

export default store;
